import { getUrl } from 'src/utils';
import { AdminType, TenantType, UserType } from 'src/types';
import { TenantForSharedUserType, UploadLogoType } from 'src/types/tenant';
import axios from '../axios';
import ROUTES from '../routes';

const tenants = {
  loadTenants: (): Promise<Partial<TenantType>[]> => axios.get(ROUTES.TENANTS),
  loadTenant: ({ id }: Partial<TenantType>): Promise<Partial<TenantType>> => axios.get(getUrl(ROUTES.TENANT, { id })),
  createTenant: (tenant: Partial<TenantType>): Promise<TenantType> => axios.post(ROUTES.TENANTS, tenant),
  updateTenant: ({ id, ...tenant }: Partial<TenantType>): Promise<TenantType> => axios.patch(getUrl(ROUTES.TENANT, { id }), tenant),
  deleteTenant: (tenant: Partial<TenantType>): Promise<TenantType> => axios.delete(getUrl(ROUTES.TENANT, tenant)),
  loadTenantAdmins: ({ id }: Partial<TenantType>): Promise<Partial<TenantType>> => axios.get(getUrl(ROUTES.TENANT_ADMINS, { id })),
  deleteTenantAdmin: ({ tenantId, uuid }: Partial<AdminType>): Promise<Partial<TenantType>> =>
    axios.delete(getUrl(ROUTES.TENANT_ADMIN, { tenantId, uuid })),
  inviteTenantAdmin: ({ id, admin }: { id: number; admin: Partial<AdminType> }) => axios.post(getUrl(ROUTES.TENANT_ADMINS_INVITE, { id }), admin),
  resendInviteTenantAdmin: ({ id, uuid }: { id: number; uuid: string }) => axios.post(getUrl(ROUTES.TENANT_ADMINS_INVITE_RESEND, { id, uuid })),
  loadTenantAdminData: ({ code }: { code: string }): Promise<Partial<AdminType>> => axios.get(getUrl(ROUTES.TENANT_USERS_AUTH, { code })),
  registerTenantAdmin: ({
    tenantId,
    code,
    adminData,
  }: {
    tenantId: number;
    code: string;
    adminData: Partial<AdminType>;
  }): Promise<Partial<AdminType>> => axios.patch(getUrl(ROUTES.TENANT_ADMIN_REGISTRATION, { tenantId, code }), adminData),
  loadStorm360Users: ({ registered }: { registered: boolean }): Promise<Partial<AdminType[]>> =>
    axios.get(getUrl(ROUTES.STORM360_USERS, { registered })),
  loadStorm360Admins: (): Promise<Partial<AdminType[]>> => axios.get(ROUTES.STORM360_ADMINS),
  loadPendingStorm360Admins: (): Promise<Partial<AdminType[]>> => axios.get(ROUTES.STORM360_PENDING_ADMINS),
  deletePendingStorm360Admins: ({ uuid }: { uuid: string }): Promise<Partial<AdminType[]>> =>
    axios.delete(getUrl(ROUTES.STORM360_PENDING_ADMINS_DELETE, { uuid })),
  inviteStorm360Admin: ({ admin }: { admin: Partial<AdminType> }) => axios.post(ROUTES.STORM360_ADMIN_INVITE, admin),
  resendInviteStorm360Admin: ({ uuid }: { uuid: string }) => axios.post(getUrl(ROUTES.RESEND_STORM360_ADMIN_INVITE, { uuid })),
  setTenantUserStatus: (uuid: string, status: number): Promise<Partial<AdminType>> =>
    axios.patch(getUrl(ROUTES.TENANT_USERS_STATUS, { uuid }), { status }),
  inviteTenantUser: ({ id, user }: { id: number; user: Partial<UserType> }) => axios.post(getUrl(ROUTES.TENANT_USERS_INVITE, { id }), user),
  inviteSharedUser: ({ id, user }: { id: number; user: Partial<UserType> }) => axios.post(getUrl(ROUTES.SHARED_USERS_INVITE, { id }), user),
  registerTenantUser: ({ code, userData }: { code: string; userData: Partial<UserType> }): Promise<Partial<AdminType>> =>
    axios.patch(getUrl(ROUTES.TENANT_USERS_AUTH, { code }), userData),
  loadTenantUsersList: ({ tenantId }: { tenantId: number }): Promise<Partial<AdminType[]>> =>
    axios.get(getUrl(ROUTES.TENANT_USERS_LIST, { tenantId })),
  loadTenantPendingUsers: ({ id }: Partial<TenantType>): Promise<Partial<AdminType[]>> => axios.get(getUrl(ROUTES.TENANT_USERS_PENDING, { id })),
  resendInviteTenantUsers: ({ id, uuid }: { id: number; uuid: string }) => axios.post(getUrl(ROUTES.TENANT_USERS_INVITE_RESEND, { id, uuid })),
  deletePendingTenantUser: ({ id, uuid }: { id: number; uuid: string }): Promise<void> =>
    axios.delete(getUrl(ROUTES.TENANT_USERS_PENDING_DELETE, { id, uuid })),
  loadTenantsForSharedUser: (): Promise<TenantForSharedUserType[]> => axios.get(ROUTES.TENANTS_FOR_SHARED_USER),
  acceptTenantInvite: (id: number): Promise<void> => axios.get(getUrl(ROUTES.TENANT_ACCEPT_INVITE, { id })),
  tenantLogoUpload: ({ cancelToken, tenantId, ...data }: Partial<UploadLogoType>): Promise<{ logoUrl: string }> =>
    axios.post(getUrl(ROUTES.TENANT_LOGO, { id: tenantId }), data, {
      headers: { 'Content-Type': 'multipart/form-data' },
      cancelToken,
    }),
  deleteTenantLogo: ({ tenantId }: { tenantId: number }) => axios.delete(getUrl(ROUTES.TENANT_LOGO, { id: tenantId })),
};

export default tenants;
